var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 542.657,
    height: 79.553,
    viewBox: "0 0 542.657 79.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1372",
    "data-name": "Rectangle 1372",
    width: 542.657,
    height: 79.553
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1410",
    "data-name": "Group 1410",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6593",
    "data-name": "Path 6593",
    d: "M0,0V11.232H18.8V78.484H30.664V11.232h18.8V0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1404",
    "data-name": "Group 1404",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1403",
    "data-name": "Group 1403",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6594",
    "data-name": "Path 6594",
    d: "M84.222,24.043c-4.591,0-8.38,2.247-11.5,6.847l-.361-5.778H61.111V81.786H72.975V53.556c0-8.838,2.812-18.28,10.707-18.28a9.507,9.507,0,0,1,5.1,1.482l1.606,1.111,2.152-10.653L92,26.725a11.669,11.669,0,0,0-7.775-2.682",
    transform: "translate(-8.389 -3.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6595",
    "data-name": "Path 6595",
    d: "M127.176,24.042c-16.317,0-28.622,12.5-28.622,29.086,0,17.224,12.4,29.726,29.486,29.726,13.938,0,23.079-8.518,25.954-16.96l.579-1.7H143.079l-.381.577c-1.8,2.719-6.087,7.28-14.658,7.28-9.742,0-16.629-5.742-17.532-14.428H155.8V53.983c0-17.069-12.3-29.941-28.62-29.941m16.61,24.378H110.523c.973-7.827,7.9-13.572,16.652-13.572,9.738,0,15.541,6.621,16.61,13.572",
    transform: "translate(-13.529 -3.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6596",
    "data-name": "Path 6596",
    d: "M199.6,49.039c-1.311-.5-2.545-.962-3.7-1.394-8.462-3.163-11.9-4.578-11.9-7.883,0-3.759,4.808-5.45,8.223-5.45,3.97,0,8.511,2.026,9.1,6.473l.148,1.118h11.679l-.085-1.366c-.6-9.713-9.258-16.5-21.056-16.5-9.58,0-19.761,5.51-19.761,15.72,0,4.759,1.681,11.648,16.178,16.494,1.285.48,2.5.921,3.635,1.337,9.363,3.417,12.6,4.817,12.6,9.112,0,3.452-4,5.771-9.951,5.771-6.609,0-11.16-2.661-12.485-7.3l-.266-.933H170.238l.18,1.446c1.343,10.748,10.342,17.164,24.073,17.164,13.176,0,22.03-6.4,22.03-15.934,0-10.379-9.055-15.011-16.925-17.881",
    transform: "translate(-23.37 -3.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6597",
    "data-name": "Path 6597",
    d: "M261.022,24.042c-17.019,0-30.35,12.87-30.35,29.3,0,16.55,13.331,29.513,30.35,29.513,16.958,0,30.241-12.963,30.241-29.513,0-16.429-13.283-29.3-30.241-29.3m0,47.579a18.176,18.176,0,1,1,0-36.346,18.174,18.174,0,1,1,0,36.346",
    transform: "translate(-31.667 -3.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6598",
    "data-name": "Path 6598",
    d: "M400.005,67.743l-17.286-42.46H369.53l24.333,56.673h12.283L430.48,25.282H417.292Z",
    transform: "translate(-50.729 -3.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6599",
    "data-name": "Path 6599",
    d: "M455.151,15.653a6.482,6.482,0,0,0,6.58-6.525,6.409,6.409,0,0,0-6.58-6.525,6.482,6.482,0,0,0-6.58,6.525,6.559,6.559,0,0,0,6.58,6.525",
    transform: "translate(-61.58 -0.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6600",
    "data-name": "Path 6600",
    d: "M445.691,35.963l4.213.428V81.956H461.66V25.283H445.691Z",
    transform: "translate(-61.184 -3.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6601",
    "data-name": "Path 6601",
    d: "M501.526,49.039c-1.311-.5-2.544-.962-3.7-1.393-8.462-3.163-11.9-4.578-11.9-7.884,0-3.759,4.808-5.45,8.222-5.45,3.97,0,8.511,2.026,9.1,6.473L503.4,41.9h11.68l-.084-1.366c-.6-9.713-9.257-16.5-21.056-16.5-9.58,0-19.761,5.51-19.761,15.72,0,4.759,1.682,11.648,16.179,16.494,1.285.48,2.5.921,3.634,1.337,9.363,3.417,12.6,4.817,12.6,9.112,0,3.452-4,5.771-9.951,5.771-6.609,0-11.16-2.661-12.485-7.3l-.266-.933H472.168l.181,1.445c1.342,10.749,10.341,17.165,24.073,17.165,13.176,0,22.03-6.4,22.03-15.934,0-10.379-9.055-15.011-16.926-17.881",
    transform: "translate(-64.819 -3.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6602",
    "data-name": "Path 6602",
    d: "M550.257,6.692H538.5V22.73h-7.779V33.962H538.5V79.4h11.755V33.962H561.6V22.73H550.257Z",
    transform: "translate(-72.857 -0.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6603",
    "data-name": "Path 6603",
    d: "M597.819,24.042c-7.54,0-15.39,2.325-23.331,6.909l-.643.371V41.747l1.916-1.077c2.8-1.573,11.315-6.357,20.438-6.357,9.337,0,12.975,4.346,12.975,15.5v2.01a33.935,33.935,0,0,0-16.217-4.152c-11.342,0-22.786,5.39-22.786,17.431,0,12.263,11.444,17.751,22.786,17.751a35.534,35.534,0,0,0,16.372-4.111l.455,3.042h11.145V49.813c0-11.063-2.395-25.771-23.11-25.771m11.355,37.5v7.438c-1.444,1.839-7.169,4.993-13.948,4.993-4.9,0-13.192-1.869-13.192-8.871,0-3.944,3.454-8.55,13.192-8.55,6.778,0,12.5,3.152,13.948,4.992",
    transform: "translate(-78.273 -3.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6604",
    "data-name": "Path 6604",
    d: "M333.7,30.783H303.034a1.209,1.209,0,0,0-1.125.75,1.186,1.186,0,0,0,.273,1.315A29.7,29.7,0,0,1,311.07,54.18a30.044,30.044,0,0,1-8.92,21.57A1.2,1.2,0,0,0,303,77.812H333.7a23.516,23.516,0,1,0,0-47.029",
    transform: "translate(-41.429 -4.226)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvg);
export default __webpack_public_path__ + "static/media/logoSvg.2135626f2be23e3ad6f6e1ffb98fae12.svg";
export { ForwardRef as ReactComponent };